export const GET_OVERVIEW = 'GET_OVERVIEW';

export const GET_OVERVIEW_SUCCESS = 'GET_OVERVIEW_SUCCESS';

export const GET_OVERVIEW_FAILED = 'GET_OVERVIEW_FAILED';